import { onAuthStateChanged, signOut } from 'firebase/auth'
import React, { useEffect, useState } from 'react';
import "./Profile.css";
import { auth, firestore } from '../../firebase/firebaseConfig';
import { Link } from "react-router-dom";
import { getDocs, collection, updateDoc, doc, onSnapshot } from "@firebase/firestore";
import Button from 'react-bootstrap/esm/Button';

function Profile (props) {
    let [ pincodesArray, setPincodesArray ] = useState( [] );
    let [ detailsObject, setDetailsObject ] = useState( {} );

    async function onload ( user ) {
        document.querySelector( ".loader-container" ).style.display = "flex";

        let pincodesDoc = await getDocs( collection( firestore, "pin" ) )
        let pincodeArray = [];
        pincodesDoc.forEach( ( element ) => {
            pincodeArray.push( element.id );
        } )
        setPincodesArray( [ ...pincodeArray ] );

        onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
            document.querySelector( ".loader-container" ).style.display = "flex";
            detailsObject = {
                name: snapshot.data().name,
                email: snapshot.data().email,
                phone: snapshot.data().mobile,
                address: snapshot.data().address,
                pincode: snapshot.data().pincode
            }
            setDetailsObject( { ...detailsObject } );
            document.querySelector( ".loader-container" ).style.display = "none";
        } )

        setTimeout( () => {
            document.getElementById( "pincode-select" ).value = detailsObject.pincode;
        }, 500 )

        document.querySelector( ".loader-container" ).style.display = "none";
    }

    async function editDetails ( event ) {
        event.preventDefault();
        await updateDoc( doc( firestore, "users", auth.currentUser.uid ), {
            name: event.target.name.value,
            email: event.target.email.value,
            mobile: event.target.phone.value,
            address: event.target.address.value,
            pincode: event.target.pincode.value
        } )
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Your Details | Profile";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( !user ) {
                window.location.href = "/";
            } else {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile,
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                        onload( user );
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            }
        } )
        document.querySelector( ".loader-container" ).style.display = "none";
    }, [] )

    return (
        <div className='profile-container'>
            <div className="profile-inner-container">
                <div>
                    <div>
                        <div>
                            {detailsObject.name}
                        </div>
                        <div>
                            Mobile Number : {detailsObject.phone}
                        </div>
                        <div>
                            Email Id : {detailsObject.email}
                        </div>
                    </div>
                    <div className='active'>
                        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.592 14.6727L21.471 12.5517L7.5 26.5227V28.6437H9.621L23.592 14.6727ZM25.713 12.5517L27.834 10.4307L25.713 8.30968L23.592 10.4307L25.713 12.5517ZM10.863 31.6437H4.5V25.2792L24.6525 5.12668C24.9338 4.84547 25.3153 4.6875 25.713 4.6875C26.1107 4.6875 26.4922 4.84547 26.7735 5.12668L31.017 9.37018C31.2982 9.65147 31.4562 10.0329 31.4562 10.4307C31.4562 10.8284 31.2982 11.2099 31.017 11.4912L10.8645 31.6437H10.863Z" fill="#95C3C8" />
                        </svg>
                        <span>Edit Details</span>
                    </div>
                    <Link to={"/orders"}>
                        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M31.5 19.6436V30.1436C31.5 30.5414 31.342 30.9229 31.0607 31.2042C30.7794 31.4855 30.3978 31.6436 30 31.6436H6C5.60217 31.6436 5.22064 31.4855 4.93934 31.2042C4.65804 30.9229 4.5 30.5414 4.5 30.1436V19.6436H3V16.6436L4.5 9.14355H31.5L33 16.6436V19.6436H31.5ZM7.5 19.6436V28.6436H28.5V19.6436H7.5ZM6.06 16.6436H29.94L29.04 12.1436H6.96L6.06 16.6436ZM9 21.1436H21V25.6436H9V21.1436ZM4.5 4.64355H31.5V7.64355H4.5V4.64355Z" fill="#97C5C9" />
                        </svg>
                        <span>My Orders</span>
                    </Link>
                    <Link to={"/wallet"}>
                        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30.0074 10.6436V7.64355H6.00732V28.6436H30.0074V25.6436H18.0074C17.1789 25.6436 16.5074 24.972 16.5074 24.1436V12.1436C16.5074 11.3151 17.1789 10.6436 18.0074 10.6436H30.0074ZM4.50732 4.64355H31.5074C32.3358 4.64355 33.0074 5.31513 33.0074 6.14355V30.1436C33.0074 30.972 32.3358 31.6436 31.5074 31.6436H4.50732C3.6789 31.6436 3.00732 30.972 3.00732 30.1436V6.14355C3.00732 5.31513 3.6789 4.64355 4.50732 4.64355ZM19.5074 13.6436V22.6436H30.0074V13.6436H19.5074ZM22.5074 16.6436H27.0074V19.6436H22.5074V16.6436Z" fill="#97C5C9" />
                        </svg>
                        <span>LB Wallet</span>
                    </Link>
                    <div>
                        <span>
                            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.6445 25.6436H30V7.64355H6V27.7211L8.6445 25.6436ZM9.6825 28.6436L3 33.8936V6.14355C3 5.74573 3.15804 5.3642 3.43934 5.08289C3.72064 4.80159 4.10218 4.64355 4.5 4.64355H31.5C31.8978 4.64355 32.2794 4.80159 32.5607 5.08289C32.842 5.3642 33 5.74573 33 6.14355V27.1436C33 27.5414 32.842 27.9229 32.5607 28.2042C32.2794 28.4855 31.8978 28.6436 31.5 28.6436H9.6825ZM16.5 21.1436H19.5V24.1436H16.5V21.1436ZM12.8505 13.3631C13.0454 12.3877 13.5132 11.4878 14.1996 10.768C14.886 10.0482 15.7626 9.53812 16.7276 9.29709C17.6925 9.05606 18.7061 9.09401 19.6503 9.40653C20.5945 9.71904 21.4306 10.2933 22.0612 11.0624C22.6918 11.8315 23.091 12.7639 23.2124 13.751C23.3338 14.7382 23.1724 15.7395 22.7469 16.6385C22.3215 17.5375 21.6495 18.2972 20.8091 18.8292C19.9687 19.3612 18.9946 19.6436 18 19.6436H16.5V16.6436H18C18.4261 16.6435 18.8435 16.5225 19.2035 16.2945C19.5635 16.0666 19.8514 15.7411 20.0337 15.3559C20.2159 14.9708 20.2851 14.5417 20.233 14.1188C20.181 13.6959 20.0099 13.2964 19.7397 12.9669C19.4696 12.6374 19.1114 12.3914 18.7068 12.2575C18.3023 12.1236 17.8681 12.1074 17.4546 12.2106C17.0412 12.3139 16.6656 12.5324 16.3715 12.8408C16.0775 13.1492 15.877 13.5347 15.7935 13.9526L12.8505 13.3631Z" fill="#95C3C8" />
                            </svg>
                            <span>Help</span>
                        </span>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.172 12.1438L8.222 7.19381L9.636 5.77981L16 12.1438L9.636 18.5078L8.222 17.0938L13.172 12.1438Z" fill="#444444" />
                        </svg>
                    </div>
                    <div onClick={event => signOut( auth )}>
                        <span>
                            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5 15.1436H24L18 22.6436L12 15.1436H16.5L16.5 1.64355L19.5 1.64355V15.1436ZM13.5 3.83055V7.01655C10.9214 8.06362 8.7867 9.97412 7.46109 12.4212C6.13548 14.8683 5.70132 17.7 6.23288 20.4319C6.76444 23.1637 8.22869 25.626 10.3751 27.3975C12.5216 29.1691 15.2169 30.1398 18 30.1436C20.786 30.1451 23.4858 29.1772 25.6362 27.4059C27.7866 25.6346 29.2537 23.1702 29.7858 20.4355C30.3179 17.7008 29.8819 14.8661 28.5525 12.4177C27.2232 9.96932 25.0833 8.05975 22.5 7.01655V3.83055C28.5855 5.74155 33 11.4266 33 18.1436C33 26.4281 26.2845 33.1436 18 33.1436C9.7155 33.1436 3 26.4281 3 18.1436C3 11.4266 7.4145 5.74155 13.5 3.83055Z" fill="#95C3C8" />
                            </svg>
                            <span>Log Out</span>
                        </span>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.172 12.1438L8.222 7.19381L9.636 5.77981L16 12.1438L9.636 18.5078L8.222 17.0938L13.172 12.1438Z" fill="#444444" />
                        </svg>
                    </div>
                </div>
                <form onSubmit={event => editDetails( event )}>
                    <div>
                        <div className='form-input-container'>
                            <div className='form-input-head'>
                                Name
                            </div>
                            <div className='form-input'>
                                <input type="text" placeholder='Enter Your Name' name="name" defaultValue={detailsObject.name} required />
                            </div>
                        </div>
                        <div className='form-input-container'>
                            <div className='form-input-head'>
                                Email Id
                            </div>
                            <div className='form-input'>
                                <input type="email" placeholder='Enter Your Email Id' name="email" defaultValue={detailsObject.email} required />
                            </div>
                        </div>
                        <div className='form-input-container'>
                            <div className='form-input-head'>
                                Phone Number
                            </div>
                            <div className='form-input'>
                                <input type="tel" placeholder='Enter Your Phone Number' name="phone" value={detailsObject.phone} minLength={10} maxLength={10} readOnly />
                            </div>
                        </div>
                        <div className='form-input-container'>
                            <div className='form-input-head'>
                                Address
                            </div>
                            <div className='form-input'>
                                <input type="text" placeholder='Enter Your Address' name="address" defaultValue={detailsObject.address} required />
                            </div>
                        </div>
                        <div className='form-input-container'>
                            <div className='form-input-head'>
                                Pincode
                            </div>
                            <div className='form-input'>
                                <select id='pincode-select' name="pincode" required>
                                    <option value="">Select Option</option>
                                    {pincodesArray.map( ( element ) => (
                                        <option value={element}>{element}</option>
                                    ) )}
                                </select>
                            </div>
                        </div>
                    </div>
                    <Button type="submit">SAVE</Button>
                </form>
            </div>
        </div>
    )
}

export default Profile